import { Backdrop } from '@mui/material';
import CenteredSpinner from './CenteredSpinner';

const FullScreenLoader = () => {
  return (
    <Backdrop open sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
      <CenteredSpinner color='inherit' />
    </Backdrop>
  );
};

export default FullScreenLoader;
